
import { Component, Vue } from 'vue-property-decorator';
import * as firebase from 'firebase/app';

@Component
export default class Articles extends Vue {
  articles: any[] = [];
  
  config = {
    itemsToShow: 2.5,
    gap: 5,
    wrapAround: true,
  };

  async mounted() {
    try {
      const db = firebase.firestore();
      const snapshot = await db.collection('articles').orderBy("id", "desc").get();
      this.articles = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error loading articles:', error);
    }
  }

  navigateToArticle(id: string) {
    this.$router.push(`/articles/${id}`);
  }
}
